import { Badge, NavigationItem } from '@dev-spendesk/grapes';
import React from 'react';
import { matchPath, NavLink, useLocation } from 'react-router-dom';

export type NavigationLinkProps = {
  className?: string;
  key: string;
  text: string;
  rightAddon?: React.ReactNode;
  path: string;
  extraMatchingPaths?: string[];
  count?: number | string;
  isActive?: boolean;
  onClick?: () => void;
};

export const NavigationLink = ({
  className,
  text,
  path,
  extraMatchingPaths = [],
  count,
  rightAddon,
  isActive,
  onClick,
  ...rest
}: NavigationLinkProps) => {
  const { pathname: currentPath } = useLocation();
  // if path contains query params, we ignore them to make sure we're matching the proper paths
  const pathToMatch = path.match(/^(.+)\?/)?.[1] ?? path;
  const isLinkActive = Boolean(
    matchPath(currentPath, {
      path: [pathToMatch].concat(extraMatchingPaths),
    }),
  );

  return (
    <NavigationItem
      {...rest}
      className={className}
      text={text}
      rightAddon={
        (rightAddon || count !== undefined) && (
          <>
            {rightAddon}
            {count !== undefined && (
              <Badge variant={isLinkActive ? 'primary' : 'secondary'}>
                {count}
              </Badge>
            )}
          </>
        )
      }
      component={NavLink}
      to={path}
      isActive={isActive ?? isLinkActive}
      onClick={onClick}
    />
  );
};
